import cx from 'classnames';
import { useState } from 'react';

import Button from '../Button/Button';
import CircularProgress from '../CircularProgress';
import ConsultationPreview from '../ConsultationPreview';
import MaterialIcon from '../Icon/MaterialIcon';
import s from './ConsultationList.module.scss';

interface ConsultationListProps {
  title: string;
  handleMore?: () => void;
  consultations: any[];
  loading?: boolean;
  pageInfo?: any;
  grid?: boolean;
}

const ConsultationList = ({
  title,
  handleMore,
  consultations,
  loading,
  pageInfo,
  grid,
}: ConsultationListProps): JSX.Element | React.ReactElement => {
  const [expanded, setExpanded] = useState(true);

  if (consultations.length === 0 && !loading) return <div />;

  return (
    <div className={s.section}>
      <button
        type="button"
        className={s.sectionHeader}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <div className={s.sectionTitle}>
          <MaterialIcon icon={expanded ? 'expand_more' : 'chevron_right'} className={s.chevron} />
          <span>{title}</span>
          {/* <span className={s.count}>{consultations.length}</span> */}
        </div>
      </button>

      {expanded && (
        <div className={cx({ [s.gridList]: grid })}>
          {consultations.map((c: any) => (
            <div key={c.id} className={cx({ [s.gridItem]: grid })}>
              <ConsultationPreview consultation={c} compact={grid} />
            </div>
          ))}

          {!!pageInfo?.hasNextPage && !loading && (
            <div className={s.loadMore}>
              <Button
                variant="text"
                onClick={(e) => {
                  e.preventDefault();
                  handleMore?.();
                }}
              >
                Load More
              </Button>
            </div>
          )}

          {loading && (
            <div className={s.loading}>
              <CircularProgress />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConsultationList;
